var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark",
      staticStyle: { "margin-bottom": "0" },
    },
    [
      _c(
        "a",
        {
          directives: [
            {
              name: "sanitizedHref",
              rawName: "v-sanitizedHref",
              value: `/#/portfolio/kanban/${_vm.workspaceId}/${_vm.projectId}`,
              expression: "`/#/portfolio/kanban/${workspaceId}/${projectId}`",
            },
          ],
          staticClass: "navbar-brand",
        },
        [_vm._v("Kanban")]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "collapse navbar-collapse", attrs: { id: "navBar" } },
        [
          _c("ul", { staticClass: "navbar-nav mr-auto" }, [
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Projects\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/projects-proposals/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/projects-proposals/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Proposals")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/projects-scheduled/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/projects-scheduled/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Scheduled")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/projects-started/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/projects-started/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Started")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/projects-finished/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/projects-finished/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Finished")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/projects-all/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/projects-all/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("All")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Manage\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/attributes/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/attributes/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Attributes")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/forms/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/forms/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Forms")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/lists-manager/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/lists-manager/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Lists")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/notifications/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/notifications/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Notifications")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/dependencies/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/dependencies/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Dependencies")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/pages/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/pages/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Request pages")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/people/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/people/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("People")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/portfolio/goals/${_vm.workspaceId}/${_vm.projectId}`,
                      expression:
                        "`/#/portfolio/goals/${workspaceId}/${projectId}`",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("Evaluation")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/portfolio/assessments/${_vm.workspaceId}/${_vm.projectId}`,
                      expression:
                        "`/#/portfolio/assessments/${workspaceId}/${projectId}`",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("Assessments")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/portfolio/plans/${_vm.workspaceId}/${_vm.projectId}`,
                      expression:
                        "`/#/portfolio/plans/${workspaceId}/${projectId}`",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("Planning")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Reporting\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/reports/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/reports/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Reports")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/portfolio/pnl/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/portfolio/pnl/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("P&L")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav" }, [
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Account\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/projects/${_vm.workspaceId}`,
                        expression: "`/#/projects/${workspaceId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Back to workspace")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/#/organizations/users/dashboard" },
                  },
                  [_vm._v("My dashboard")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/#/organizations/users/account" },
                  },
                  [_vm._v("Manage your account")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/organizations/sessions/close" },
                  },
                  [_vm._v("Sign out")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navBar",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }